import { render } from "./whiteList.vue?vue&type=template&id=981eea52"
import script from "./whiteList.vue?vue&type=script&lang=js"
export * from "./whiteList.vue?vue&type=script&lang=js"

import exportComponent from "/root/workspace/zyy-iot_zyy-iot-web-v2_Ejzw/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__